import { Injectable, computed, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppModuleCode, StoreInfo } from '../models/tenant.model';

// Loja (empresa) cuja vitrine está aberta: /<slug>
@Injectable({ providedIn: 'root' })
export class StoreService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/stores`;

  private readonly current = signal<StoreInfo | null>(null);
  readonly store = this.current.asReadonly();
  readonly slug = computed(() => this.current()?.slug ?? '');

  // Carrega a loja pelo endereço (reaproveita a já carregada ao navegar entre as telas dela)
  load(slug: string): Observable<StoreInfo> {
    const loaded = this.current();
    if (loaded?.slug === slug) return of(loaded);
    return this.http.get<StoreInfo>(`${this.apiUrl}/${slug}`).pipe(tap(store => this.current.set(store)));
  }

  hasModule(module: AppModuleCode): boolean {
    return this.current()?.modules.includes(module) ?? false;
  }

  // Rota dentro da loja atual: link('checkout') -> ['/', 'zesalgados', 'checkout']
  link(...segments: string[]): string[] {
    return ['/', this.slug(), ...segments];
  }

  // O mesmo, como URL: url('login') -> '/zesalgados/login'
  url(...segments: string[]): string {
    return '/' + [this.slug(), ...segments].join('/');
  }
}
